import { Service } from '@phishtool/service';
import getQuotePDFController, { GetQuotePDFRequestDataSchema, } from '~server/controllers/service/enterprise-quotes/get-quote-pdf';
import { rateLimitMiddleware } from '~server/middleware';
export class EnterpriseQuoteService extends Service {
    constructor() {
        super(...arguments);
        this.getPDFURL = this.addSingletonFileQuery({
            controller: getQuotePDFController,
            schema: GetQuotePDFRequestDataSchema,
            routeId: 'pdf',
            middleware: [rateLimitMiddleware],
        });
    }
}
